import React, { useState } from 'react';
import { connect } from 'react-redux';
import ChatWindow from './ChatWindow';
import './chatbot.css';

/**
 * Widget flutuante do chatbot
 * Exibido apenas quando o usuário está autenticado
 */
const ChatWidget = ({ usuario }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  // Não mostrar se usuário não estiver autenticado
  if (!usuario || !usuario.id) {
    return null;
  }

  return (
    <>
      {/* Janela do chat */}
      {isOpen && <ChatWindow onClose={() => setIsOpen(false)} />}

      {/* Botão flutuante */}
      <button
        className={`chatbot-widget-button ${isOpen ? 'open' : ''}`}
        onClick={toggleChat}
        aria-label={isOpen ? "Fechar chat" : "Abrir chat"}
        title={isOpen ? "Fechar chat" : "Fale com nosso assistente virtual"}
      >
        {!isOpen ? (
          <i className="fa fa-comment-dots" />
        ) : (
          <i className="fa fa-chevron-down" />
        )}
      </button>

      {/* Tooltip de boas-vindas (primeira vez) */}
      {!isOpen && (
        <div className="chatbot-tooltip">
          Precisa de ajuda? 💬
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  usuario: state.usuario.autenticado
});

export default connect(mapStateToProps)(ChatWidget);
